import { Http } from '@/lib/http';
import {
  assertRangeRowCount,
  assertRangeRows
} from '@/modules/shared/utils/range-row-limits.mjs';

const getNumericFinalRangeMax = (ranges) => {
  const lastIndex = ranges.length - 1;
  const lastRange = ranges[lastIndex];
  const currentMax = Number(lastRange?.to);
  const previousMax = Number(ranges[lastIndex - 1]?.to);
  const currentMin = Number(lastRange?.from);
  const lowerBound = Math.max(
    Number.isFinite(previousMax) ? previousMax : Number.NEGATIVE_INFINITY,
    Number.isFinite(currentMin) ? currentMin : Number.NEGATIVE_INFINITY
  );

  if (Number.isFinite(currentMax) && currentMax > lowerBound) {
    return currentMax;
  }

  return Number.isFinite(lowerBound) ? lowerBound + 1 : 1;
};

export const prepareLoanPriorityRangesForApi = (ranges = []) => {
  if (!Array.isArray(ranges) || ranges.length === 0) return ranges;

  return ranges.map((range, index) => ({
    ...range,
    to:
      index === ranges.length - 1
        ? getNumericFinalRangeMax(ranges)
        : range.to
  }));
};

const prepareLoanPriorityPayloadForApi = (payload) => {
  if (Array.isArray(payload)) {
    return prepareLoanPriorityRangesForApi(payload);
  }

  if (Array.isArray(payload?.data)) {
    return {
      ...payload,
      data: prepareLoanPriorityRangesForApi(payload.data)
    };
  }

  return payload;
};

export class LoanPriorityService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/loan-priority-settings';
  }

  createLoanPrioritySetting(payload) {
    return this.httpClient().post(
      `${this.endpoint}`,
      prepareLoanPriorityPayloadForApi(payload)
    );
  }

  fetchLoanPrioritySettings(type, page, limit) {
    console.log('type', type);
    return this.httpClient().get(`${this.endpoint}/${type}?page=${page}&limit=${limit}`);
  }

  fetchLoanPrioritySetting(id) {
    return this.httpClient().get(`${this.endpoint}/${id}`);
  }

  updateLoanPrioritySetting(id, updates) {
    const apiUpdates = prepareLoanPriorityRangesForApi(updates);
    assertRangeRows(apiUpdates);
    return this.httpClient().put(`${this.endpoint}/${id}`, { data: apiUpdates });
  }

  generateRange(rangeConfig) {
    assertRangeRowCount(rangeConfig?.numberOfRecords);
    return this.httpClient().post(`${this.endpoint}/generate-range`, rangeConfig);
  }

}
